import {
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  Stack,
} from "@chakra-ui/react";
import DropFilesHere from "modules/messaging/_shared/drop-files-here";
import { usePanelSize } from "modules/providers/panel-size-provider";
import React, { memo, useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { THREAD_DRAFT_ID } from "modules/utils/Constants";
import { useFile } from "modules/providers/file-provider";
import ComposeMessageThreadSubject from "../messaging/_shared/compose-message-thread-subject";
import ComposeMessageThreadHeader from "../messaging/_shared/compose-message-thread-header";
import QuillMessageComposer, {
  IQuillEditorHandle,
} from "../messaging/compose/quill-message-composer";
import { MessageThreadType } from "gql/graphql";

const ComposeThreadDrawer: React.FC = () => {
  const { uploadFiles } = useFile();
  const { rightWidth } = usePanelSize();

  const onFileListUpload = useCallback(
    (files: File[]) => uploadFiles(THREAD_DRAFT_ID, files),
    [uploadFiles],
  );

  const { getRootProps, isDragActive } = useDropzone({
    onDrop: onFileListUpload,
    noClick: true,
  });

  const quillEditorRef = useRef<IQuillEditorHandle>(null);

  return (
    <DrawerContent {...getRootProps()} w={rightWidth} maxW={rightWidth}>
      <DropFilesHere isDragActive={isDragActive} width={rightWidth} />
      <DrawerHeader px={3} py={0}>
        <Stack spacing={4}>
          <ComposeMessageThreadHeader
            draftId={THREAD_DRAFT_ID}
            title="New Thread"
            type={MessageThreadType.Thread}
            quillEditorRef={quillEditorRef}
          />
          <ComposeMessageThreadSubject draftId={THREAD_DRAFT_ID} />
        </Stack>
      </DrawerHeader>

      <DrawerBody p={0} display="flex" flexDirection="column" overflow="hidden">
        <QuillMessageComposer
          ref={quillEditorRef}
          draftId={THREAD_DRAFT_ID}
          type={MessageThreadType.Thread}
          expandOnInit
          autoFocus
        />
      </DrawerBody>
    </DrawerContent>
  );
};

export default memo(ComposeThreadDrawer);
